import * as api from './cloudsaveApi';
import { getCurrentUserId } from 'auth/userIdentity';
import { withOwnerCheck } from './withOwnerCheck';

// Saga and imperative reads retain their fresh-request and offline workflows.
// Keep native Error instances intact for withRetry.
const guard =
  <Args extends unknown[], Result>(read: (...args: Args) => Promise<Result>) =>
  (...args: Args) =>
    withOwnerCheck(getCurrentUserId(), () => read(...args));

export const getAll = guard(api.getAll);
export const getOne = guard(api.getOne);
export const getTemplates = guard(api.getTemplates);
export const getApprovedFiles = guard(api.getApprovedFiles);
export const getArchived = guard(api.getArchived);
